import { connect } from 'react-redux';
import downloadPdfActions from 'store/downloadPdf/actions';
import PaymentConfirmationNew from 'pages/PaymentConfirmationNew';

const mapStateToProps = state => {
  return {
    isPDFDownloading: state.downloadPdf.isPDFDownloading,
    eSignedData: state.signUp.signData,
    receiptPDF: state.downloadPdf.receiptPDF,
    membershipAgreementPDF: state.downloadPdf.membershipAgreementPDF,
    receiptPdfData: state.downloadPdf.receiptPdfData,
  };
};
const mapDispatchToProps = {
  loadMembershipAgreementPDF:
    downloadPdfActions.Creators.loadMembershipAgreementPDFRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentConfirmationNew);
